import { Button, Group, Stack, Text, TextInput, ToggleButton } from '@ekhodealer/ekho-common/rev';

import { useDiscountFieldError, useDiscountFormField } from '../../atoms/discountFormAtoms';
import { DiscountType } from '../types';

const generateRandomCode = (): string => {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	return Array.from({ length: 12 }, () => chars[Math.floor(Math.random() * chars.length)]).join(
		'',
	);
};

export const DiscountTypeSection = () => {
	const [discountType] = useDiscountFormField('discountType');
	const [method, setMethod] = useDiscountFormField('method');
	const [code, setCode] = useDiscountFormField('code');
	const [title, setTitle] = useDiscountFormField('title');
	const codeError = useDiscountFieldError('code');
	const titleError = useDiscountFieldError('title');

	const discountTypeLabel =
		discountType === DiscountType.AMOUNT_OFF_PRODUCTS
			? 'Amount off products'
			: discountType === DiscountType.AMOUNT_OFF_ORDER
				? 'Amount off order'
				: 'Free shipping';

	return (
		<Stack itemsSpacing='16'>
			<Text size='body' weight='semibold'>
				1. {discountTypeLabel}
			</Text>

			<Stack itemsSpacing='12'>
				<Text size='footnote' color='secondary'>
					Select a method
				</Text>
				<Group itemsSpacing='8' itemsAlignX='start'>
					<ToggleButton
						isSelected={method === 'code'}
						onChange={() => setMethod('code')}
						rounding='full'
						size='large'>
						Discount code
					</ToggleButton>
					<ToggleButton
						isSelected={method === 'automatic'}
						onChange={() => setMethod('automatic')}
						rounding='full'
						size='large'>
						Automatic discount
					</ToggleButton>
				</Group>
			</Stack>

			{method === 'code' ? (
				<Stack itemsSpacing='4'>
					<Group itemsAlignX='space-between'>
						<Text size='footnote'>Discount code</Text>
						<Button variant='ghost' onPress={() => setCode(generateRandomCode())}>
							Generate random code
						</Button>
					</Group>
					<TextInput
						value={code}
						onChange={(value) => setCode(value)}
						placeholder='e.g. SUMMER2026'
						size='medium'
						hasError={codeError}
					/>
					<Text size='footnote' color='secondary'>
						Customers must enter this code at checkout.
					</Text>
				</Stack>
			) : (
				<Stack itemsSpacing='4'>
					<Text size='footnote'>Title</Text>
					<TextInput
						value={title}
						onChange={(value) => setTitle(value)}
						placeholder='e.g. Summer Sale'
						size='medium'
						hasError={titleError}
					/>
					<Text size='footnote' color='secondary'>
						Customers will see this in their cart and at checkout.
					</Text>
				</Stack>
			)}
		</Stack>
	);
};
